var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"sentiment-trends"},[(_vm.isRerender)?_c('sentiment-trend-chart',{attrs:{"search-text":_vm.searchText},on:{"checkedDate":_vm.checkedDate,"done":_vm.chartDone}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }